// src/hooks/useConfirmDelete.jsx
//
// Re-usable confirm-before-delete dialog for the 9 destructive
// delete buttons across the app. Used together with the global
// toast system.
//
//   const { confirmDelete, ConfirmDialog } = useConfirmDelete();
//
//   <button onClick={() => confirmDelete("project", async () => {
//     await api.delete(...);
//     toast.success("Deleted");
//   })}>Delete</button>
//
//   {ConfirmDialog}   // place once in the component's JSX tree

import React, { useState } from "react";

export function useConfirmDelete() {
  const [pending, setPending] = useState(null);
  // pending shape: { label, onConfirm }

  const confirmDelete = (label, onConfirm) => {
    setPending({ label, onConfirm });
  };

  const close = () => setPending(null);

  const ConfirmDialog = pending ? (
    <div
      onClick={close}
      role="dialog"
      aria-modal="true"
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.7)",
        zIndex: 9998,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#0f0f0f",
          border: "0.5px solid #222",
          borderRadius: 12,
          padding: "24px 28px",
          maxWidth: 340,
          width: "90vw",
        }}
      >
        <div style={{ fontSize: 15, color: "#fff", marginBottom: 8 }}>
          Delete {pending.label}?
        </div>
        <div style={{ fontSize: 13, color: "#666", marginBottom: 20 }}>
          This cannot be undone.
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <button
            type="button"
            onClick={() => {
              const fn = pending.onConfirm;
              close();
              try { fn && fn(); } catch (_) { /* caller handles toast */ }
            }}
            style={{
              flex: 1,
              padding: "9px 0",
              background: "rgba(226,75,74,0.1)",
              border: "0.5px solid rgba(226,75,74,0.3)",
              borderRadius: 8,
              color: "#E24B4A",
              fontSize: 13,
              cursor: "pointer",
              fontWeight: 500,
            }}
          >
            Delete
          </button>
          <button
            type="button"
            onClick={close}
            style={{
              flex: 1,
              padding: "9px 0",
              background: "transparent",
              border: "0.5px solid #222",
              borderRadius: 8,
              color: "#666",
              fontSize: 13,
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  ) : null;

  return { confirmDelete, ConfirmDialog };
}

export default useConfirmDelete;
